import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    mode: 'light',

    primary: {
      main: '#FE4444',
      light: '#FFFFFF',
      dark: '#FE4444',
    },
    secondary: {
      main: '#64748B',
      light: '#FFFFFF',
      dark: '#151515',
    },
    neutral: {
      main: '#ffffff',
      contrastText: '#000000',
      dark: '#ffffff',
    },
    error: {
      main: '#F55A5A',
      light: '#F55A5A',
      dark: '#F55A5A',
    },
    info: {
      main: '#EBEBEB',
      light: '#EBEBEB',
      dark: '#EBEBEB',
    },
    text: {
      main: '#AFB5BA',
      primary: '#AFB5BA',
    },
  },
  MuiSlider: {
    root: {
      color: '#000', // Set the desired color here
    },
    thumb: {
      backgroundColor: '#000', // Set the desired color for the thumb here
    },
    track: {
      color: '#000', // Set the desired color for the track here
    },
    rail: {
      color: 'gray', // Set the desired color for the rail here
    },
  },
  typography: {
    button: {
      textTransform: 'none',
    },
    allVariants: {
      color: '#151515',
    },
    fontFamily: ['Roboto Condensed'],
    fontSize: 16,
    fontWeightRegular: 400,
    fontWeightBold: 700,
    h1: {
      fontSize: '54px',
      fontWeight: 800,
    },
    h2: {
      fontSize: '36px',
      fontWeight: 600,
    },
    h3: {
      fontSize: '28px',
      fontWeight: 700,
    },
    h4: {
      fontSize: '24px',
      fontWeight: 600,
    },
    h5: {
      fontSize: '18px',
      fontWeight: 700,
    },
    h6: {
      fontSize: '20px',
      fontWeight: 400,
    },
    body1: {
      fontSize: '14px',
      fontWeight: 600,
    },
    body2: {
      fontSize: '12px',
      fontWeight: 400,
    },
    subtitle1: {
      fontSize: '10px',
      fontWeight: 400,
    },
  },
  shape: {
    borderRadius: 2,
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
});
